var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRisk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5842 5.61409L10.9696 8.17118C9.36571 8.87846 8.29201 10.4698 8.19922 12.2652V22.3712C8.30526 24.1938 9.12711 25.8804 10.4924 27.0501L16.1923 31.4162C18.247 32.858 20.9511 32.858 23.0057 31.4162L28.7056 27.0501C30.0709 25.8804 30.8928 24.1938 30.9988 22.3712V12.2652C30.9193 10.4698 29.8456 8.86485 28.2284 8.15757L21.6139 5.61409C20.3016 5.19244 18.8965 5.19244 17.5842 5.61409V5.61409Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6758 18.7262L17.8099 20.916L23.5098 15.0674",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRisk);
export default __webpack_public_path__ + "static/media/Low_Risk.40adcb7355f345fc7bce425d5f3576c7.svg";
export { ForwardRef as ReactComponent };